import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { createCommission } from 'bundles/apex/deals/show/store/deal/actions';

import Button from 'shared/button';
import ContactSelector from 'bundles/backoffice/contacts/selector';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';

export function AddOutsideBrokerModal({ createCommission, show, transactionSide, transactionSideOptions, onClose }) {
  const [contact, setContact] = useState();
  const [saving, setSaving] = useState();
  const [formTransactionSide, setTransactionSide] = useState();

  function reset() {
    setContact(null);
    if (transactionSide) {
      setTransactionSide(transactionSide);
    } else if (transactionSideOptions) {
      setTransactionSide(transactionSideOptions[0][0]);
    }
  }

  async function handleSave() {
    setSaving(true);
    await createCommission({ contact, outside: true, transactionSide: formTransactionSide });
    setSaving(false);
    onClose();
  }

  return (
    <Modal
      className="visible-overflow"
      show={show}
      onHide={onClose}
      onShow={reset}
    >
      <Modal.Header closeButton>
        Add Outside Broker
      </Modal.Header>

      <Modal.Body>
        <label>Select Contact</label>
        <ContactSelector contact={contact} onChange={setContact} />

        {!transactionSide && transactionSideOptions &&
          <form className="form form-horizontal mt-3">
            <ManagedFormGroup
              label="Transaction Side"
              name="transactionSide"
              required
              type="select"
              value={formTransactionSide}
              onValueChange={setTransactionSide}
            >
              {transactionSideOptions.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </ManagedFormGroup>
          </form>
        }
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onClose} />
        <Button.Primary disabled={!contact || saving} onClick={handleSave}>
          Add Broker
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

AddOutsideBrokerModal.propTypes = {
  createCommission: PropTypes.func.isRequired,
  show: PropTypes.bool,
  transactionSide: PropTypes.string,
  transactionSideOptions: PropTypes.array,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  transactionSideOptions: state.options.transactionSide,
});

const mapDispatchToProps = {
  createCommission,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddOutsideBrokerModal);
